module.exports = __webpack_public_path__ + "assets/775c24ca83d5939b02f718a0240cbcd6.mp4";